export default __webpack_public_path__ + "static/media/c-logo-light.946dd471.png";